import axios from "axios";
import { store } from "../config/store";
import { actionsAuth } from "../redux/auth.slice";
import { shouldIgnoreUrlStatus } from "../config/signozConfig";
import { safeHttpErrorLog } from "../utils/errorHandler";
import { setupApiTracing } from "./tracing";

const API = axios.create({
  // .. where we make our configurations
  baseURL: process.env.REACT_APP_URL,
  timeout: 10000000,
  headers: {
    "Content-Type": "application/json",
    // 'Access-Control-Allow-Origin': '*'
  },
});

// Tracing request ke SigNoz (tanpa header/body). Didaftarkan sebelum interceptor
// respons di bawah, yang mengubah error jaringan menjadi respons 408.
setupApiTracing(API);

// Helper function untuk handle token invalid dan redirect ke login
const handleTokenInvalid = () => {
  store.dispatch(actionsAuth.logout({}));
  localStorage.clear();
  window.location.href = "/masuk";
};

// Cek apakah response menunjukkan token invalid
const isTokenInvalid = (status, data) => {
  // Handle standard 401 Unauthorized
  if (status === 401) return true;

  // Handle status 400 dengan message "Token invalid"
  if (status === 400 && data?.message === "Token invalid") return true;

  // Handle response dengan status_code 400 dan message "Token invalid" di body
  if (data?.status === false && data?.status_code === 400 && data?.message === "Token invalid") return true;

  return false;
};

// For POST requests
API.interceptors.response.use(
  (res) => {
    // Cek juga response sukses yang mungkin berisi token invalid di body
    const { data } = res;
    if (isTokenInvalid(res.status, data)) {
      handleTokenInvalid();
      return Promise.reject(new Error("Token invalid"));
    }
    return res;
  },
  (err) => {
    if (err.code === "ECONNABORTED" || !err.response) {
      return Promise.resolve({
        status: 408,
        data: {
          message: "Koneksi timeout, silakan coba lagi nanti",
          success: false,
        },
      });
    }

    const { status, data } = err.response || {};
    const url = err.config?.url || "";

    // Filter error yang tidak perlu di-trace ke SigNoz
    if (shouldIgnoreUrlStatus(url, status)) {
      console.warn(`⚠️ ${status} error for ${url} (not traced to SigNoz):`, data?.message || err.message);
    } else {
      // Log error yang penting ke SigNoz
      // Tanpa body request: bisa berisi password / data pribadi
      safeHttpErrorLog(err, url, status, {
        method: err.config?.method,
      });
    }

    if (isTokenInvalid(status, data)) {
      handleTokenInvalid();
    }
    return Promise.reject(err);
  }
);

export default API;
